import styles from 'components/menu/menu.module.css';
import { useTranslation } from 'react-i18next';
import { IS_MOBILE } from 'constants/responsive';
import {
    ABOUT_US_URL,
    CONTACT_US_URL,
    DANCE_SHOW_URL,
    GALLERY_URL,
    HOME_URL,
    WELCOME_ANIM_URL,
} from 'constants/navigation';
import { startTransition } from 'react';
import { LanguageLink } from 'components/menu/LanguageLink';

export const Menu = ({
    isMobile = false,
    toggleMenu,
    isFooter = false,
}: {
    isMobile?: boolean;
    toggleMenu?: () => void;
    isFooter?: boolean;
}) => {
    const { t } = useTranslation();

    const menuItems = [
        { id: 11, title: t('menu.Main'), link: HOME_URL },
        { id: 1, title: t('menu.AboutUs'), link: ABOUT_US_URL },
        {
            id: 2,
            title: t('menu.WelcomePerformances'),
            link: WELCOME_ANIM_URL,
        },
        { id: 3, title: t('menu.DanceShow'), link: DANCE_SHOW_URL },
        { id: 4, title: t('menu.Gallery'), link: GALLERY_URL },
        { id: 5, title: t('menu.ContactUs'), link: CONTACT_US_URL },
    ];

    const shouldAddGap = isFooter && !IS_MOBILE;
    const shouldDirectColumn = isFooter && IS_MOBILE;

    const listStyles =
        isMobile || shouldDirectColumn
            ? `${styles.menuList} ${styles.menuList__column}`
            : `${styles.menuList}`;

    const handleMenuClick = () => {
        startTransition(() => {
            toggleMenu && toggleMenu();
        });
    };

    return (
        <nav className={styles.menu}>
            <ul
                className={listStyles}
                style={{ gap: shouldAddGap ? '24px' : 0 }}
            >
                {menuItems.map(({ id, link, title }) => (
                    <li key={id} className={styles.menuItem}>
                        <LanguageLink to={link} onClick={handleMenuClick}>
                            {title}
                        </LanguageLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};
